export default __webpack_public_path__ + "static/media/igpostchallenger.4f0ca54f.png";